<template>
  <page-layout :desc="'用户发票记录....'" :title="'发票列表'">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="发票编号">
                <a-input v-model="queryParam.invoiceCode" placeholder=""/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="发票状态">
                <a-select v-model="queryParam.invoiceStatus" placeholder="请选择" default-value="0">
                  <a-select-option value="0">待出票</a-select-option>
                  <a-select-option value="1">待邮寄</a-select-option>
                  <a-select-option value="2">已邮寄</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="search">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <!--<a-button type="primary" icon="audit" @click="createInvoice">开具发票</a-button>-->
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        rowKey="id"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      >
        <template
          slot="invoiceStatus"
          slot-scope="invoiceStatus">
          <a-badge :status="invoiceStatus | statusTypeFilter" :text="invoiceStatus | statusTextFilter"/>
        </template>
      </a-table>
    </a-card>
  </page-layout>
</template>

<script>
import STable from '@/components/table/'
import PageLayout from '@/components/page/PageLayout'
import { fetchList } from '@/api/invoice/invoice'

export default {
  name: 'TableList',
  components: {
    STable, PageLayout
  },
  data () {
    return {
      dataSource: [],
      hackReset: true,
      loading: true,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '发票编号',
          dataIndex: 'invoiceCode',
          width: 200
        },
        {
          title: '发票状态',
          dataIndex: 'invoiceStatus',
          key: 'invoiceStatus',
          scopedSlots: { customRender: 'invoiceStatus' },
          width: 200
        },
        {
          title: '发票明细',
          dataIndex: 'content',
          width: 300
        },
        {
          title: '发票金额',
          dataIndex: 'price',
          width: 200
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          width: 200
        },
        {
          title: '统一社会信用代码/税号',
          dataIndex: 'uniformSocialCreditCode',
          width: 200
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: 160,
          sorter: true
        },
        {
          table: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  filters: {
    statusTextFilter (status) {
      const statusMap = {
        '0': '待出票',
        '1': '待邮寄',
        '2': '已邮寄'
      }
      return statusMap[status]
    },
    statusTypeFilter (type) {
      const statusTypeMap = {
        '0': 'warning',
        '1': 'processing',
        '2': 'success'
      }
      return statusTypeMap[type]
    }
  },
  created () {
  },
  mounted () {
    this.loadData({})
  },
  methods: {
    search () {
      this.loading = true
      this.loadData(this.queryParam)
    },
    loadData (queryParam) {
      fetchList(queryParam).then((res) => {
        if (res.code === 1) {
          this.dataSource = res.data
          this.loading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>
